<div class="flex flex-row gap-2 items-center">
    @if (status() === Deposit.StatusEnum.ABORTED) {
        <fa-icon
            class="text-custom-red"
            size="lg"
            [icon]="['fas', 'xmark']"
            [matTooltip]="'aborted' | transloco" />
    } @else if (isValid()) {
        @switch (status()) {
            @case (Deposit.StatusEnum.DONE) {
                @if (deposit()?.hadDataAtImport === false) {
                    <fa-icon
                        class="text-custom-orange"
                        matTooltipClass="whitespace-pre-line"
                        size="lg"
                        [icon]="['fas', 'triangle-exclamation']"
                        [matTooltip]="`✖︎ ${('depositNoData' | transloco)}`" />
                } @else {
                    <fa-icon
                        class="text-custom-green"
                        size="lg"
                        [icon]="['fad', 'check-circle']"
                        [matTooltip]="'done' | transloco" />
                }
            }
            @case (Deposit.StatusEnum.ERRORED) {
                <fa-icon
                    class="text-custom-red"
                    size="lg"
                    [icon]="['fad', 'circle-exclamation']"
                    [matTooltip]="'errored' | transloco" />
            }
            @case (Deposit.StatusEnum.FAILED) {
                <fa-icon
                    class="text-custom-red"
                    size="lg"
                    [icon]="['fad', 'triangle-exclamation']"
                    [matTooltip]="'failed' | transloco" />
            }
            @case (Deposit.StatusEnum.IMPORTING) {
                <fa-icon
                    class="text-custom-blue fa-spin"
                    size="lg"
                    [icon]="['fad', 'spinner-third']"
                    [matTooltip]="'importing' | transloco" />
            }
            @case (Deposit.StatusEnum.VALIDATING) {
                <fa-icon
                    class="text-custom-blue fa-spin"
                    size="lg"
                    [icon]="['fad', 'spinner-third']"
                    [matTooltip]="'validating' | transloco" />
            }
            @case (Deposit.StatusEnum.EXTRACTING) {
                <fa-icon
                    class="text-custom-blue fa-spin"
                    size="lg"
                    [icon]="['fad', 'spinner-third']"
                    [matTooltip]="'extracting' | transloco" />
            }
        }
    } @else {
        <fa-icon
            class="text-custom-orange"
            matTooltipClass="whitespace-pre-line"
            size="lg"
            [icon]="['fas', 'triangle-exclamation']"
            [matTooltip]="
                [
                    `✔︎ ${('depositHasData' | transloco)}`,
                    `✖︎ ${hasStandard() ? ('errorStandardDeposit' | transloco) : ('errorValidityDeposit' | transloco)}`,
                ].join('\n')
            " />
    }
</div>
